import React from 'react';
import { Block, BLOCKS, Inline } from '@contentful/rich-text-types';

import { ILearningCenterSidebarCalloutFields } from '../../../../../types/contentful';

import RichText from '../../../RichText';
import CtaWidget from '../../../CtaWidget';

import { ctaWidgetEnum, DEFAULT_EMAIL_LABEL } from '../../../CtaWidget/shared';

import { RenderNode } from '@contentful/rich-text-react-renderer';

const disclaimerOverrideOptions: RenderNode = {
  [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => {
    return <p className="text-center text-xs">{children}</p>;
  }
};

const secondaryTextOverrideOptions: RenderNode = {
  [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => {
    return (
      <p className="whitespace-pre-wrap break-words text-center text-base leading-[1.25rem] tablet:text-lg tablet:leading-[1.625rem] [&:not(:last-child)]:mb-6">
        {children}
      </p>
    );
  }
};

export function SidebarCallout({
  headerText,
  bodyText,
  ctaWidget,
  secondaryText,
  disclaimer,
  segmentEventProperty = 'newsletter'
}: ILearningCenterSidebarCalloutFields) {
  return (
    <div
      data-testid="sidebar-callout-layout"
      className="!m-0 flex flex-wrap content-center items-center rounded-2xl bg-white p-5 tablet:mt-4"
    >
      <div className="column w-full flex-col !p-0">
        {headerText && (
          <h3 className="text-center text-[1.375rem] font-medium leading-6 tracking-[0.5px] tablet:text-[1.625rem] tablet:leading-8">
            {headerText}
          </h3>
        )}
        <div className="box mt-4 tablet:mt-6">
          {bodyText && (
            <p className="text-center text-base font-normal leading-[1.25rem] tablet:text-[1.125rem] tablet:leading-[1.625rem]">
              {bodyText}
            </p>
          )}
        </div>
        <div
          className="mx-auto mb-0 mt-4 box-border flex w-full flex-col items-center justify-center justify-self-center tablet:mt-6"
          data-e2e="sidebar-cta"
        >
          <CtaWidget
            id="sidebar-cta-phone-number"
            aria-label="Email address input"
            module="Sidebar Callout"
            errorPosition="bottom"
            responsive
            designType={ctaWidgetEnum.EMAIL}
            {...ctaWidget?.fields}
            label={DEFAULT_EMAIL_LABEL}
            sysId={ctaWidget?.sys?.contentType?.sys?.id}
            additionalSegmentData={{ segmentEventProperty }}
          />
        </div>
        {disclaimer && (
          <div className="mt-3">
            <RichText
              data={disclaimer}
              overrideOptions={disclaimerOverrideOptions}
            />
          </div>
        )}
        {secondaryText && (
          <div className="box mt-6 tablet:mt-8">
            <RichText
              data={secondaryText}
              overrideOptions={secondaryTextOverrideOptions}
            />
          </div>
        )}
      </div>
    </div>
  );
}
